export default "__VITE_ASSET__BV3jjsX5__";